import { orderData, setPriceOrderData } from '../../orderData';
import { currentCurrency } from '../currentCurrency';

const refs = {
  totalPrice: document.querySelector('.total-price'),
  firstTripPrice: document.getElementById('firstTrip-price'),
  returnTripPrice: document.getElementById('returnTrip-price'),
};
const { totalPrice, firstTripPrice, returnTripPrice } = refs;

export const renderPriceInfo = () => {
  // Оновлення загальної ціни в orderData і на UI
  const totalTripPrice = orderData.selectedCars
    ? Object.values(orderData.selectedCars).reduce(
        (total, { pricing }) => total + pricing.price_total,
        0
      )
    : 0;
  let totalOrderPrice = totalTripPrice;
  // Якщо є зворотній рейс, подвоюємо ціну
  if (orderData.returnTrip) {
    totalOrderPrice *= 2;
  }
  setPriceOrderData({
    totalTripPrice,
    totalOrderPrice,
    currency: currentCurrency.title,
  });

  totalPrice.textContent = `${totalOrderPrice} ${currentCurrency.symbol}`;
  firstTripPrice.textContent = `${totalTripPrice} ${currentCurrency.symbol}`;
  if (orderData.returnTrip) {
    returnTripPrice.textContent = `${totalTripPrice} ${currentCurrency.symbol}`;
  }
};
